import { Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useSidebar } from "@/components/ui/sidebar";
import { UserMenu } from "@/components/user-menu";
import { useTabsState } from "@/contexts/tabs-context";

/**
 * Mobile-only header with hamburger menu and user avatar.
 * Visible on screens below `md` (768px). Hidden on desktop.
 *
 * Shows the active project name (or "Decision Formula" on home).
 * The hamburger button opens the left sidebar as a Sheet
 * via shadcn's `toggleSidebar()`.
 */
export function MobileHeader() {
  const { toggleSidebar } = useSidebar();
  const { tabs, activeTabId } = useTabsState();

  const activeTab = activeTabId ? tabs.find((t) => t.tabId === activeTabId) : null;
  const title = activeTab?.name ?? "Decision Formula";

  return (
    <header className="flex md:hidden h-14 items-center border-b px-4 gap-3 bg-background">
      <Button
        variant="ghost"
        size="icon"
        className="touch:min-h-11 touch:min-w-11 shrink-0"
        onClick={toggleSidebar}
      >
        <Menu className="size-5" />
        <span className="sr-only">Toggle sidebar</span>
      </Button>

      <span className="text-sm font-semibold truncate flex-1 min-w-0">{title}</span>

      <UserMenu />
    </header>
  );
}
